import React, { useState } from 'react'

import Categories from './Categories'
import SubCategories from './SubCategories'

const Resources = () => {
  const [isView, setIsView] = useState<string>('categories')

  const [id, setId] = useState('')
  const [sId, setSId] = useState('')
  const [breadcrumbArray, setBreadcrumbArray] = useState<
    { id: string; name: string }[]
  >([])

  return (
    <>
      {isView === 'categories' && (
        <Categories
          setId={setId}
          setSId={setSId}
          setIsView={setIsView}
          breadcrumbArray={breadcrumbArray}
          setBreadcrumbArray={setBreadcrumbArray}
        />
      )}
      {isView === 'subCategories' && (
        <SubCategories
          id={id}
          sId={sId}
          setId={setId}
          setIsView={setIsView}
          breadcrumbArray={breadcrumbArray}
          setBreadcrumbArray={setBreadcrumbArray}
        />
      )}
    </>
  )
}

export default Resources
